<template>
  <v-container
    fluid
  >
    <v-card-title>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        :label="$t('search')"
        single-line
        hide-details
        class="mb-2"
      />
      <v-btn
        color="primary"
        class="ms-2"
        @click="newItem()"
      >
        <i class="fas fa-layer-plus fa-lg me-2" />
        {{ $t('new') }}
      </v-btn>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="dataRows"
      :items-per-page="tableCPP"
      :search="search"
      :loading="loading"
      class="elevation-1"
    >
      <template v-slot:item.actions="{ item }">
        <v-btn-toggle>
          <v-btn
            fab
            x-small
            depressed
            class="light-green"
            @click="uploadImagesItem(item)"
          >
            <i
              class="fal fa-photo-video fa-lg"
            />
          </v-btn>
          <v-btn
            fab
            x-small
            class="blue"
            @click="showItem(item)"
          >
            <i
              class="fal fa-eye fa-lg"
            />
          </v-btn>
          <v-btn
            fab
            x-small
            depressed
            class="warning"
            @click="editItem(item)"
          >
            <i
              class="fal fa-pencil fa-lg"
            />
          </v-btn>
          <v-btn
            fab
            x-small
            depressed
            class="error"
            @click="deleteConfirm(item)"
          >
            <i
              class="fal fa-trash-alt fa-lg"
            />
          </v-btn>
        </v-btn-toggle>
      </template>
      <template v-slot:item.autoplay_text="{ item }">
        <v-chip
          :color="getStatusColor(item.autoplay_text)"
        >
          {{ $t(item.autoplay_text) }}
        </v-chip>
      </template>
    </v-data-table>
    <v-dialog
      v-model="dialog"
      :persistent="true"
      :internal-activator="true"
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-card-title>
          <span
            class="headline"
          >
            {{ formTitle }}
          </span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col
                cols="12"
                sm="8"
                md="12"
              >
                <v-text-field
                  v-model="editedItem.title"
                  :label="$t('title')"
                />
              </v-col>
              <v-col
                cols="12"
                sm="8"
                md="10"
              >
                <v-subheader
                  class="pl-0"
                  v-html="$t('delay')"
                />
                <v-slider
                  v-model="editedItem.delay"
                  thumb-label="always"
                  :max="30"
                  :min="1"
                  :thumb-size="24"
                  hide-details
                />
              </v-col>
              <v-col
                cols="12"
                sm="4"
                md="2"
              >
                <v-switch
                  v-model="editedItem.autoplay"
                >
                  <template
                    v-slot:prepend
                  >
                    <span class="mt-1 me-2">{{ $t('autoplay') }}</span>
                  </template>
                </v-switch>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn
            color="blue darken-1"
            text
            @click="close"
          >
            {{ $t('cancel') }}
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            :loading="btnLoadingSave"
            :disabled="btnLoadingSave"
            @click="save"
          >
            {{ $t('save') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogShow"
      :persistent="true"
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col
                cols="12"
                sm="9"
                md="12"
              >
                <p>{{ $t('id') }} : <strong>{{ editedItem.id }}</strong></p>
              </v-col>
              <v-col
                cols="12"
                sm="8"
                md="12"
              >
                <p>{{ $t('title') }} : <strong>{{ editedItem.title }}</strong></p>
              </v-col>
              <v-col
                cols="12"
                sm="8"
                md="10"
              >
                <v-subheader
                  class="pl-0"
                  v-html="$t('delay')"
                />
                <v-slider
                  v-model="editedItem.delay"
                  thumb-label="always"
                  :max="30"
                  :min="1"
                  :thumb-size="24"
                  readonly
                  hide-details
                />
              </v-col>
              <v-col
                cols="6"
                sm="3"
                md="2"
              >
                <v-switch
                  v-model="editedItem.autoplay"
                  disabled
                >
                  <template
                    v-slot:prepend
                  >
                    <span class="mt-1 me-2 text-no-wrap">{{ $t('autoplay') + ` : ` + $t(editedItem.autoplay_text) }}</span>
                  </template>
                </v-switch>
              </v-col>
            </v-row>
            <v-divider />
            <v-row>
              <v-col
                cols="12"
                sm="6"
                md="4"
              >
                <p>{{ $t('created_at') }} : <strong>{{ editedItem.created_at | moment("jYYYY/jM/jD HH:mm") }}</strong></p>
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="4"
              >
                <p>{{ $t('updated_at') }} : <strong>{{ editedItem.updated_at | moment("jYYYY/jM/jD HH:mm") }}</strong></p>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn
            color="blue darken-1"
            text
            @click="close"
          >
            {{ $t('close') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogImages"
      :persistent="true"
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-card-text>
          <v-container>
            <v-row>
              <v-file-input
                v-model="files"
                counter
                :label="$t('select_files')"
                multiple
                prepend-icon="mdi-paperclip"
                accept="image/*"
                outlined
                dense
                :show-size="1000"
                class="me-4"
              >
                <template v-slot:selection="{ index, text }">
                  <v-chip
                    v-if="index < 3"
                    label
                    small
                  >
                    {{ text }}
                  </v-chip>
                  <v-chip
                    v-else-if="index === 3"
                    label
                    small
                  >
                    +{{ files.length - 3 }}
                  </v-chip>
                </template>
              </v-file-input>
              <v-btn
                depressed
                class="me-2 blue"
                :loading="btnLoadingUpload"
                :disabled="btnLoadingUpload"
                @click="upload()"
              >
                <i
                  class="fad fa-upload fa-lg"
                />
              </v-btn>
            </v-row>
            <v-divider />
            <v-row>
              <v-col cols="12">
                <v-container fluid>
                  <v-row>
                    <v-col
                      v-for="image in imageFiles"
                      :key="image"
                      class="d-flex child-flex"
                      cols="2"
                    >
                      <v-hover
                        open-delay="1000"
                        v-slot:default="{ hover }"
                      >
                        <v-card
                          flat
                          tile
                          class="d-flex"
                        >
                          <v-img
                            :src="image.file"
                            :lazy-src="image.file"
                            aspect-ratio="1"
                            class="grey lighten-2"
                          >
                            <v-expand-transition>
                              <div
                                v-if="hover"
                                class="d-flex transition-fast-in-fast-out grey darken-4 v-card--reveal py-3"
                              >
                                <v-btn
                                  small
                                  color="red"
                                  @click="deleteImage(image.id)"
                                >
                                  {{ $t('delete') }}
                                </v-btn>
                              </div>
                            </v-expand-transition>
                            <template v-slot:placeholder>
                              <v-row
                                class="fill-height ma-0"
                                align="center"
                                justify="center"
                              >
                                <v-progress-circular
                                  indeterminate
                                  color="grey lighten-5"
                                />
                              </v-row>
                            </template>
                          </v-img>
                        </v-card>
                      </v-hover>
                    </v-col>
                  </v-row>
                </v-container>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn
            color="blue darken-1"
            text
            @click="close"
          >
            {{ $t('close') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div class="text-center">
      <v-bottom-sheet
        v-model="deleteSheet"
        persistent
        inset
      >
        <v-sheet
          class="text-center"
          height="200px"
        >
          <v-btn
            class="mt-6"
            color="error"
            :loading="btnLoadingDelete"
            :disabled="btnLoadingDelete"
            @click="deleteItem(editedItem)"
          >
            {{ $t('delete') }}
          </v-btn>
          <v-btn
            class="mt-6 ms-2"
            color="green"
            @click="deleteSheet = !deleteSheet"
          >
            {{ $t('close') }}
          </v-btn>
          <div class="py-3">
            {{ $t('permanently_delete?') }} {{ $t('you_can_not_undo.') }}
            <p class="pt-3">
              {{ $t('id') }} : <strong>{{ editedItem.id }}</strong> ,
              {{ $t('title') }} : <strong>{{ editedItem.title }}</strong>
            </p>
          </div>
        </v-sheet>
      </v-bottom-sheet>
    </div>
    <v-snackbar
      v-model="snackbar"
      :color="snackbarColor"
      :timeout="6000"
    >
      {{ snackbarText }}
      <template v-slot:action="{ attrs }">
        <v-btn
          dark
          text
          tile
          small
          outlined
          v-bind="attrs"
          @click="snackbar = false"
        >
          {{ $t('close') }}
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
  import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
  export default {
    name: 'Operations',
    data () {
      return {
        headers: [],
        dataRows: [],
        categoryRows: [],
        dynamicColumns: [],
        uploadRules: [
          value => !value || value.size < 2000000 || this.$t('file_size_should_be_less_than_2_mb!'),
        ],
        tableCPP: 10,
        search: '',
        loading: true,
        dialog: false,
        dialogShow: false,
        dialogImages: false,
        editedIndex: -1,
        editedItem: {},
        defaultItem: {},
        formTitle: '',
        deleteSheet: false,
        btnLoadingDelete: false,
        btnLoadingSave: false,
        btnLoadingUpload: false,
        snackbar: false,
        snackbarColor: '', // ['success', 'info', 'error', 'cyan darken-2']
        snackbarText: '',
        editor: ClassicEditor,
        editorConfig: {
          language: {
            ui: 'en',
            content: 'fa',
          },
          toolbar: [
            'undo',
            'redo',
            'fontColor',
            'fontBackgroundColor',
            'fontSize',
            '|',
            'bold',
            'italic',
            'underline',
            'removeFormat',
            'alignment',
            'bulletedList',
            'numberedList',
            'horizontalLine',
            '|',
            'link',
            'imageUpload',
            'insertTable',
            'mediaEmbed',
          ],
          image: {
            toolbar: [
              'imageTextAlternative',
              'imageStyle:full',
              'imageStyle:side',
            ],
          },
          table: {
            contentToolbar: [
              'tableColumn',
              'tableRow',
              'mergeTableCells',
            ],
          },
        },
        files: [],
        imageFiles: [],
      }
    },
    async created () {
      await this.getData()
      await this.getHeaders()
    },
    methods: {
      getHeaders () {
        this.headers = []
        this.headers.push({ text: this.$t('id'), value: 'id' })
        this.headers.push({
          text: this.$t('title'),
          value: 'title',
        })
        this.headers.push({
          text: this.$t('delay'),
          value: 'delay',
        })
        this.headers.push({
          text: this.$t('autoplay'),
          value: 'autoplay_text',
        })
        this.headers.push({
          text: this.$t('images'),
          value: 'images_count',
        })
        this.headers.push({ text: this.$t('actions'), value: 'actions', sortable: false })
      },
      getData () {
        this.$http.post('sliders/index').then(
          response => {
            this.dataRows = response.data.Sliders
            this.editedItem = Object.assign({}, this.dataRows[0])
            const tempArray = []
            Object.keys(this.editedItem).forEach(function (item) {
              Object.assign(tempArray, { [item]: null })
            })
            this.defaultItem = tempArray
            this.loading = false
          },
          error => {
            if (error.data.code === 2001) {
              this.$router.push('/login')
            } else {
              this.snackbarColor = 'error'
              this.snackbarText = this.$t('server_error') + ' | 0x935'
              this.snackbar = true
            }
          }).catch(error => {
          this.snackbarColor = 'error'
          this.snackbarText = this.$t('server_error') + ' | 0x936'
          this.snackbar = true
          console.log(error)
        })
      },
      newItem () {
        this.formTitle = this.$t('new')
        this.editedIndex = -1
        this.editedItem = Object.assign({}, this.defaultItem)
        this.dialog = true
      },
      editItem (item) {
        this.formTitle = this.$t('edit')
        this.editedIndex = this.dataRows.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },
      uploadImagesItem (item) {
        this.imageFiles = []
        this.editedIndex = this.dataRows.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogImages = true
        this.$http.post('sliders/showImages', {
          sliderId: this.editedItem.id,
        }).then(response => {
          this.imageFiles = response.data.SliderImages
        }, error => {
          if (error) {
            this.snackbarColor = 'error'
            this.snackbarText = this.$t('server_error') + ' | 0x937'
            this.snackbar = true
          }
        }).catch(error => {
          if (error) {
            this.snackbarColor = 'error'
            this.snackbarText = this.$t('server_error') + ' | 0x938'
            this.snackbar = true
          }
        })
      },
      deleteImage (imageID) {
        this.$http.post('sliders/destroyImage', {
          id: imageID,
        }).then(
          response => {
            const index = this.imageFiles.indexOf(this.imageFiles.find(x => x.id === imageID))
            this.imageFiles.splice(index, 1)
            this.snackbarColor = 'success'
            this.snackbarText = this.$t('item_deleted')
            this.snackbar = true
          },
          error => {
            if (error.data.code === 2001) {
              this.$router.push('/login')
            } else {
              this.snackbarColor = 'error'
              this.snackbarText = this.$t('server_error') + ': sliders/delete|901'
              this.snackbar = true
            }
          }).catch(error => {
          this.snackbarColor = 'error'
          this.snackbarText = this.$t('server_error') + ': sliders/delete|902'
          this.snackbar = true
          console.log(error)
        })
      },
      deleteConfirm (item) {
        this.editedItem = Object.assign({}, item)
        this.deleteSheet = true
      },
      showItem (item) {
        this.editedItem = Object.assign({}, item)
        this.dialogShow = true
      },
      deleteItem (item) {
        this.btnLoadingDelete = true
        this.$http.post('sliders/delete', {
          id: item.id,
        }).then(
          response => {
            const index = this.dataRows.indexOf(this.dataRows.find(x => x.id === item.id))
            this.dataRows.splice(index, 1)
            this.deleteSheet = false
            this.btnLoadingDelete = false
            this.snackbarColor = 'success'
            this.snackbarText = this.$t('item_deleted')
            this.snackbar = true
          },
          error => {
            if (error.data.code === 2001) {
              this.$router.push('/login')
            } else {
              this.snackbarColor = 'error'
              this.snackbarText = this.$t('server_error') + ' | 0x939'
              this.snackbar = true
              this.btnLoadingDelete = false
            }
          }).catch(error => {
          if (error) {
            this.snackbarColor = 'error'
            this.snackbarText = this.$t('server_error') + ' | 0x940'
            this.snackbar = true
            this.btnLoadingDelete = false
          }
        })
      },
      save () {
        this.btnLoadingSave = true
        if (this.editedIndex > -1) {
          this.$http.post('sliders/update', this.editedItem).then(
            response => {
              Object.assign(this.dataRows[this.editedIndex], this.editedItem)
              this.btnLoadingSave = false
              this.snackbarColor = 'success'
              this.snackbarText = this.$t('item_updated')
              this.snackbar = true
              this.close()
            },
            error => {
              if (error.data.code === 2001) {
                this.$router.push('/login')
              } else {
                this.btnLoadingSave = false
                this.snackbarColor = 'error'
                this.snackbarText = this.$t('server_error') + ' | 0x941'
                this.snackbar = true
              }
            }).catch(error => {
            if (error) {
              this.btnLoadingSave = false
              this.snackbarColor = 'error'
              this.snackbarText = this.$t('server_error') + ' | 0x942'
              this.snackbar = true
            }
          })
        } else {
          this.editedItem.language_id = 1
          this.$http.post('sliders/create', this.editedItem).then(
            response => {
              this.dataRows.push(response.data.Slider)
              this.btnLoadingSave = false
              this.snackbarColor = 'success'
              this.snackbarText = this.$t('item_inserted')
              this.snackbar = true
              this.close()
            },
            error => {
              if (error.data.code === 2001) {
                this.$router.push('/login')
              } else {
                this.btnLoadingSave = false
                this.snackbarColor = 'error'
                this.snackbarText = this.$t('server_error') + ' | 0x943'
                this.snackbar = true
              }
            }).catch(error => {
            this.btnLoadingSave = false
            this.snackbarColor = 'error'
            this.snackbarText = this.$t('server_error') + ' | 0x944'
            this.snackbar = true
            console.log(error)
          })
        }
      },
      close () {
        this.dialog = false
        this.dialogShow = false
        this.dialogImages = false
        this.files = []
        this.editedIndex = -1
      },
      upload () {
        const formData = new FormData()
        this.btnLoadingUpload = true
        this.files.forEach(function (value, index) {
          formData.append('file' + index, value)
        })
        console.log(this.files.length)
        formData.append('sliderId', this.editedItem.id)
        formData.append('fileCount', this.files.length)
        this.$http.post('sliders/uploadImage', formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        }).then(response => {
          this.imageFiles = response.data.SliderImages
          this.files = []
          this.btnLoadingUpload = false
        }, error => {
          if (error) {
            this.snackbarColor = 'error'
            this.snackbarText = this.$t('server_error') + ' | 0x945'
            this.snackbar = true
            this.btnLoadingUpload = false
          }
        }).catch(error => {
          if (error) {
            this.snackbarColor = 'error'
            this.snackbarText = this.$t('server_error') + ' | 0x946'
            this.snackbar = true
            this.btnLoadingUpload = false
          }
        })
      },
      getStatusColor (text) {
        let returnColor
        switch (text) {
          case 'deactivate':
            returnColor = 'red'
            break
          case 'active':
            returnColor = 'green'
            break
          default:
            returnColor = 'yellow'
        }
        return returnColor
      },
    },
  }
</script>

<style scoped>

</style>
